 

const MARKETING_BASE = "https://tenxenage-mktng-webapp-backend-prod-716737067852.us-central1.run.app";
const AGENT_BASE = "https://tenx-mktng-agent.tenxengage.com/api/v1";
const ENV = {
  MARKETING: {
    CAREERS: `${MARKETING_BASE}/careers`,
    GET_STARTED: `${MARKETING_BASE}/getstarted`,
    NEWSLETTER: `${MARKETING_BASE}/subscribe`,
    CAMPAIGNS: `${MARKETING_BASE}/campaigns`,
    WORKSHOPS: `${MARKETING_BASE}/workshops`,
  },
  AGENT: {
    CHAT: `${AGENT_BASE}/chat`,
    INIT: `${AGENT_BASE}/init`,
  },
};

export default ENV;
